import {Component, Input} from '@angular/core';
import {Quote, QuoteState} from '../../model/quote';
import * as LayoutActions from '../../../core/actions/layout.actions';
import * as QuoteActions from '../../actions/quote.action';
import {Store} from '@ngrx/store';


@Component({
    selector: "quote-order-complete",
    templateUrl: "./quote-order-complete.component.html",
    styleUrls: ["./quote-order-complete.component.scss"]
})


export class QuoteOrderCompleteComponent {

    @Input() quote: Quote;

    constructor(private store: Store<QuoteState>) {
    }

    back() {
        this.store.dispatch(LayoutActions.closeQuoteViewSelection());
    }

    onDownloadQuote() {
        this.store.dispatch(QuoteActions.download({quote: this.quote}));
    }
}
